import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { BuyNumberStepsProvider } from 'pages/settings/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'
import { useNumbersLayerContext } from 'pages/settings/pages/numbers/context/numbersLayerContext'

const BuyNumberProviderLayoutContent = observer(() => {
  return (
    <>
      <Outlet />
    </>
  )
})

export const BuyNumberProviderLayout = () => {
  const numbersLayerStore = useNumbersLayerContext()

  return (
    <BuyNumberStepsProvider numbersLayerStore={numbersLayerStore}>
      <BuyNumberProviderLayoutContent />
    </BuyNumberStepsProvider>
  )
}
